import { Toast as BaseToast } from '@base-ui/react';
import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import type { ToastObjectOverrides } from '~/utils/toast';

import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { closeStyle, contentStyle, iconStyle, titleStyle, toastStyle, wrapperStyle } from './Toast.css';

type Props = {
  toast: BaseToast.Root.ToastObject & ToastObjectOverrides;
};

export const Toast = ({ toast }: Props) => {
  const { t } = useTranslation(['common']);
  const toastManager = BaseToast.useToastManager();

  const type = toast.type;

  return (
    <BaseToast.Root
      className={clsx(toastStyle, statusColorThemes[type])}
      onClick={() => toastManager.close(toast.id)}
      swipeDirection="up"
      toast={toast}
    >
      <BaseToast.Content className={contentStyle}>
        <Icon
          className={iconStyle}
          name={match(type)
            .returnType<IconName>()
            .with('success', () => 'Check')
            .with('info', () => 'Info')
            .with('warning', () => 'Warning')
            .with('danger', () => 'Error')
            .with('neutral', () => 'Info')
            .with('discovery', () => 'Info')
            .exhaustive()}
        />

        <div className={wrapperStyle}>
          <BaseToast.Title className={titleStyle} />

          <BaseToast.Description />
        </div>
      </BaseToast.Content>

      <BaseToast.Close aria-label={t('common:actions.close')} className={closeStyle}>
        <Icon name="CloseSmall" />
      </BaseToast.Close>
    </BaseToast.Root>
  );
};
